export default __webpack_public_path__ + "static/media/walker-silhouette-gray.04ae9aae.svg";